import { render } from "./SMSEditor.vue?vue&type=template&id=01fd3724&ts=true"
import script from "./SMSEditor.vue?vue&type=script&lang=ts"
export * from "./SMSEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__